//
//
//
//
//
//
//
//
//


export default {
  data () {
    return {
    }
  },
  methods: {
    // 取消
    paymentCancelBtn () {
      this.$store.commit('PAYMENT_PROMPT_STATUS', { type: false })
    },
    // 下载
    paymentLoadingBtn () {
      location.href = 'http://download.gushi.com/app/download/pages/download_yds.html'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PaymentPrompt.vue